<template>
	<div class="goods-form-wrapper" @keypress.esc="cancel">
		<div class="header-sidebar mb-4" slot="header">
			<h4 class="pull-left">
				{{ $t(`${section.toLowerCase()}.${mode}`) }}
			</h4>
			<b-button class="pull-right close-btn" @click="cancelAndClearInventory" type="button" variant="link"><i
				class="fa fa-close"></i></b-button>
			<div class="clearfix"></div>
			<hr>
		</div>
		<b-form>
			<b-row>
				<b-col v-if="isChiqim || isOff" cols="6">
					<b-form-group breakpoint="lg" label-size="sm" label-cols="4"
								  :label="$t('incomes.create.from-warehouse')" label-for="refName" class="required ml-1"
								  size="sm">
						<b-form-select size="sm" :options="departments" v-model="formtItem.fromDepartmentId">
							<template slot="first">
								<option :value="null" disabled>-- {{ $t('incomes.create.warehouse') }} --</option>
							</template>
						</b-form-select>

					</b-form-group>
				</b-col>
				<b-col v-if="isKirim" cols="6">
					<b-form-group breakpoint="lg" label-size="sm" label-cols="4"
								  :label="$t('incomes.create.to-warehouse')" label-for="refName" class="required ml-1"
								  size="sm">
						<b-form-select size="sm" :options="departments" name="toDepartment"
									   v-validate="validators.toDepartment" :state="checkField('toDepartment')"
									   :disabled="formtItem.documentStatus == 'RECOUNT' ? true : false"
									   v-model="formtItem.toDepartmentId">
							<template slot="first">
								<option :value="null">-- {{ $t('incomes.create.warehouse') }} --</option>
							</template>
						</b-form-select>

					</b-form-group>
				</b-col>
				<b-col v-if="isTransfer" cols="6">
					<b-form-group breakpoint="lg" label-size="sm" label-cols="4" label-for="refName"
								  class="required ml-1" size="sm">
						<template slot="label">
							{{ $t('incomes.create.from-warehouse') }} <span class="text-danger">*</span>
						</template>
						<b-form-select size="sm" name="fromDepartment" v-model="formtItem.fromDepartmentId"
									   v-validate="validators.fromDepartment">
							<option v-for="(selectOption, indexOpt) in departments" :key="indexOpt"
									:value="selectOption.value"
									:disabled="selectOption.value === formtItem.toDepartmentId">
								{{ selectOption.text }}
							</option>
							<template slot="first">
								<option :value="null" disabled>-- {{ $t('incomes.create.warehouse') }} --</option>
							</template>
						</b-form-select>

					</b-form-group>
				</b-col>
				<b-col v-if="isTransfer" cols="6">
					<b-form-group breakpoint="lg" label-size="sm" label-cols="4"
								  :label="$t('incomes.create.to-warehouse')" label-for="refName" class="required ml-1"
								  size="sm">
						<template slot="label">
							{{ $t('incomes.create.to-warehouse') }} <span class="text-danger">*</span>
						</template>
						<b-form-select size="sm" name="toDepartmentId" v-model="formtItem.toDepartmentId"
									   v-validate="validators.toDepartmentId">
							<option v-for="(selectOption, indexOpt) in toDepartments" :key="indexOpt"
									:value="selectOption.value"
									:disabled="selectOption.value === formtItem.fromDepartmentId || !selectOption.saleType"
									:style="!selectOption.saleType ? 'color:red' : ''">
								{{ selectOption.text }}
								{{ !selectOption.saleType ? ' &nbsp;&nbsp;(' + $t('sale_type_undefined') + ')' : '' }}
							</option>
							<template slot="first">
								<option :value="null" disabled>-- {{ $t('incomes.create.warehouse') }} --</option>
							</template>
						</b-form-select>

					</b-form-group>
				</b-col>
				<b-col>
					<b-form-group breakpoint="lg" label-size="sm" :label-cols="isKirim ? '4' : '2'" :label="isKirim ? 'Сч/фактура поставщика' : $t('incomes.create.reason')"
								  label-for="refName" label-class="ml-1" class="required" size="sm">
						<b-form-input :required="true" size="sm" id="reason" v-model="formtItem.reason"
									  :disabled="formtItem.documentStatus == 'RECOUNT' ? true : false"
									  :placeholder="isKirim ? 'Сч/фактура поставщика' : $t('incomes.create.reason')"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="6">
					<b-form-group breakpoint="lg" label-size="sm" label-cols="4"
								  :label="$t('incomes.create.reg-number')" label-for="refName" label-class="ml-1"
								  @focus="$event.target.select()" class="required">
						<b-form-input :required="true" size="sm" id="regNumber" class="ml-1"
									  :disabled="formtItem.documentStatus == 'RECOUNT' ? true : false"
									  v-model="formtItem.regNumber"
									  :placeholder="$t('incomes.create.reg-number')"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col cols="3">
					<date-picker v-model="formtItem.regDate"
								 size="sm"
								 lang="ru"
								 valueType="format"
								 :disabled="formtItem.documentStatus == 'RECOUNT' ? true : false"
								 format="DD-MM-YYYY"
								 :placeholder=" $t('incomes.create.reg-date')"></date-picker>
					<!--					<b-input-group-addon>-->
					<!--						<b-button size="sm" disabled>-->
					<!--							<i class="fa fa-calendar"></i>-->
					<!--						</b-button>-->
					<!--					</b-input-group-addon>-->
				</b-col>
				<b-col v-if="isKirim" cols="3">
					<b-input-group size="sm">
						<!--					<input type="date"  mask="11-11-1111" name="regDate"  class="ml-1 form-control form-control-sm" -->
						<!--								   />-->
						<date-picker
							v-model="formtItem.customsRegDate"
							size="sm"
							lang="ru"
							:disabled="formtItem.documentStatus == 'RECOUNT' ? true : false"
							:placeholder=" $t('kirim.customDate')"
							valueType="format"
							format="DD-MM-YYYY"
						></date-picker>
						<!--					<b-input-group-addon>-->
						<!--						<b-button size="sm" >-->
						<!--							<i class="fa fa-calendar"></i>-->
						<!--						</b-button>-->
						<!--					</b-input-group-addon>-->
					</b-input-group>
				</b-col>
				<b-col v-if="isOff" cols="6">
					<b-form-group breakpoint="lg" label-size="sm" label-cols="4" label="Тип документа" label-for="refName" class="required" size="sm">
						<b-form-select v-model="formtItem.documentType" value="id" value-field="id" text-field="name" label-field="name" size="sm" :options="docTypes" name="documentType"/>
					</b-form-group>
				</b-col>
			</b-row>

			<contr-agent-select v-if="isKirim" :label="$t('incomes.create.counteragent')"
								:disabled="formtItem.documentStatus == 'RECOUNT' ? true : false"
								:options="dropDowns.counterparties.items" v-model="formtItem.contragentId"
								@reload="fetchList" @lock="$emit('lock', true)"></contr-agent-select>

			<div class="mt-1">
				<b-button class="pull-right" size="sm" v-b-toggle.collapse1 variant="light">
					<i class="fa fa-plus-circle"></i> {{ $t('incomes.create.additional') }}
				</b-button>
				<div class="clearfix"></div>
				<b-collapse id="collapse1" class="mt-2">
					<div class="mt-1">
						<b-row>
							<b-col cols="6">
								<b-form-group breakpoint="lg" label-size="sm" label-cols="4"
											  :label="$t('incomes.create.from')" label-for="refName"
											  class="required mb-1">
									<multiselect class="pull-left with-clear" v-model="dropDowns.employees.from"
												 :options="employees" :searchable="true"
												 :loading="dropDowns.product.loading" :close-on-select="true"
												 label="name" :selectLabel="''"
												 :deselectLabel="''" track-by="id" :custom-label="fullName"
												 @search-change="fetchEmployees($event)"
												 :placeholder="$t('incomes.create.select-employee')">

										<template slot="singleLabel" slot-scope="props">
											{{ props.option.firstName }}
										</template>
									</multiselect>
									<b-button class="pull-right" @click="dropDowns.employees.from = null"
											  style="position: absolute; right:6px" size="sm" variant="light">x
									</b-button>
									<div class="clearfix"></div>
								</b-form-group>
							</b-col>
							<b-col cols="6">
								<b-form-group breakpoint="lg" label-size="sm" label-cols="4"
											  :label="$t('incomes.create.to')" label-for="refName"
											  class="required mb-1">
									<multiselect class="pull-left with-clear" v-model="dropDowns.employees.to"
												 :options="employees" :searchable="true" :selectLabel="''"
												 deselectLabel="''" :loading="dropDowns.product.loading"
												 :close-on-select="true"
												 label="name" track-by="id" :custom-label="fullName"
												 @search-change="fetchList($event)"
												 :placeholder="$t('incomes.create.select-employee')">

										<template slot="singleLabel" slot-scope="props">
											{{ props.option.firstName }}
										</template>
									</multiselect>
									<b-button class="pull-right" @click="dropDowns.employees.to = null"
											  style="position: absolute; right:6px" size="sm" variant="light">x
									</b-button>
									<div class="clearfix"></div>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row>
							<b-col cols="6">
								<b-form-group breakpoint="lg" label-size="sm" label-cols="4"
											  :label="$t('incomes.create.responsible')" label-for="refName"
											  class="required mb-1">
									<multiselect class="pull-left with-clear" v-model="dropDowns.employees.responsible"
												 :options="employees" :searchable="true" :selectLabel="''"
												 deselectLabel="''" :loading="dropDowns.product.loading"
												 :close-on-select="true" label="name" track-by="id"
												 :custom-label="fullName" @search-change="fetchEmployees($event)"
												 :placeholder="$t('incomes.create.select-employee')">

										<template slot="singleLabel" slot-scope="props">
											{{ fullName(props.option) }}
										</template>
									</multiselect>
									<b-button class="pull-right" @click="dropDowns.employees.responsible = null"
											  style="position: absolute; right:6px" size="sm" variant="light">x
									</b-button>
									<div class="clearfix"></div>
								</b-form-group>
							</b-col>
							<b-col cols="6">
								<b-form-group breakpoint="lg" label-size="sm" label-cols="4"
											  :label="$t('incomes.create.responsible')" label-for="refName"
											  class="required mb-1">
									<multiselect class="pull-left with-clear" v-model="dropDowns.employees.responsible2"
												 :options="employees" :searchable="true" :selectLabel="''"
												 deselectLabel="''" :loading="dropDowns.product.loading"
												 :close-on-select="true" label="name" track-by="id"
												 :custom-label="fullName" @search-change="fetchEmployees($event)"
												 :placeholder="$t('incomes.create.select-employee')">

										<template slot="singleLabel" slot-scope="props">
											{{ props.option.firstName }}
										</template>
									</multiselect>
									<b-button class="pull-right" @click="dropDowns.employees.responsible2 = null"
											  style="position: absolute; right:6px" size="sm" variant="light">x
									</b-button>
									<div class="clearfix"></div>

								</b-form-group>
							</b-col>
							<b-col cols="6">
								<b-form-group breakpoint="lg" label-size="sm" label-cols="4"
											  :label="$t('incomes.create.initiator')" label-for="refName"
											  class="required mb-1">
									<multiselect class="pull-left with-clear" v-model="dropDowns.employees.initiator"
												 :options="employees" :searchable="true" :selectLabel="''"
												 deselectLabel="''" :loading="dropDowns.product.loading"
												 :close-on-select="true" label="name" track-by="id"
												 :custom-label="fullName" @search-change="fetchEmployees($event)"
												 :placeholder="$t('incomes.create.initiator')">

										<template slot="singleLabel" slot-scope="props">
											{{ props.option.firstName }}
										</template>
									</multiselect>
									<b-button class="pull-right" @click="dropDowns.employees.initiator = null"
											  style="position: absolute; right:6px" size="sm" variant="light">x
									</b-button>
									<div class="clearfix"></div>
								</b-form-group>
							</b-col>

						</b-row>
					</div>
				</b-collapse>
			</div>
			<br>
			<!-- IF MODE IS CREATE -->
			<create-items :mode="mode" :document-id="formtItem.id" :section="section" :items="formtItem.whItems" :status="formtItem.documentStatus"
						  @success="addItem" @successExcel="successExcel" @cancelExcel="cancelExcel"
						  @changeRowVariant="changeRowVariant" :allTotalCount="allTotalCount"
						  :incomeTotal="incomeTotal" :priceTotal="priceTotal" :department="departmentId"
						  :toDepartmentId="formtItem.toDepartmentId" :depSaleTypeOld="computedDepSaleTypeForChild"
						  :currency-rate="currencyRate" :depCurrencyName="depCurrencyName"
						  :incomeCurrency="incomeCurrency" v-if="$can('create', 'warehouse-document-item')"
						  :depsSelected="depsSelected" :toDepartmentObject="toDepartmentForCurrency"
			>
			</create-items>

			<ItemList v-if="showItems" :items="formtItem.whItems" @remove="removeItem" :mode="mode" :section="section"
					  :depCurrencyName="isKirim ? toDepartmentForCurrency.currencyName : fromDepartmentForCurrency.currencyName"
					  :depSaleType="isTransfer ? toDepartmentForCurrency.saleType : fromDepartmentForCurrency.saleType"></ItemList>
			<div class="text-center mb-3" v-if="!showItems">
				<b-spinner size="sm" variant="primary"></b-spinner>
			</div>
			<b-row>
				<b-col cols="3"></b-col>
				<b-col cols="9">
					<b-form-group breakpoint="lg" label-size="sm" label-cols="2" :label="$t('comment')"
								  label-for="refName" class="required">
						<b-form-textarea v-model="formtItem.comment" :placeholder="$t('comment')"></b-form-textarea>
					</b-form-group>

				</b-col>
			</b-row>
		</b-form>
		<div class="modal-actions">
			<b-row class="align-items-center">
				<b-col cols="6" class="mb-3 mb-xl-0">
					<b-row>
						<b-col cols="3">
							<b-button block size="sm" type="button" @click="cancelAndClearInventory"
									  variant="outline-danger">{{
									$t('cancel')
								}}
							</b-button>
						</b-col>
						<b-col cols="3" v-if="isKirim || isTransfer">
							<b-button block :disabled="whDocSaveDisabled" type="button" size="sm"
									  class="btn btn-warning"
									  @click="storeSusPend(true)" variant="primary">
								{{ $t('save') }}
							</b-button>
						</b-col>
						<b-col cols="3" v-else>
							<b-button block :disabled="whDocSaveDisabled" type="button" size="sm"
									  class="btn btn-warning"
									  @click="saveDocWriteOff(false)" variant="primary">
								{{ $t('save') }}
							</b-button>
						</b-col>
						<b-col cols="6" v-if="isKirim || isTransfer">
							<b-button block :disabled="whDocSaveDisabled" type="button" class="btn btn-success"
									  size="sm"
									  @click="store(true)" variant="primary">{{ $t('warehouse.document.saveAndFinish') }}
							</b-button>
						</b-col>
						<b-col cols="6" v-else>
							<b-button block :disabled="whDocSaveDisabled" type="button" class="btn btn-success"
									  v-if="$can('write', 'off warehouse-document manager')"
									  size="sm"
									  @click="saveDocWriteOff(true)" variant="primary">{{ $t('warehouse.document.saveAndFinish') }}
							</b-button>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</div>
		<b-modal v-model="depWarning" hide-title="true" ref="depWarningModal" @ok="depWarningOk"
				 @cancel="depWarningCancel" ok-title="Да" cancel-title="Отмена">
			<h5>Вы изменили отдел, в этом случае удаляется все добавленные товары. Продолжать? </h5>
		</b-modal>
		<b-modal v-model="dateConfirmModal" @ok="saveTransferDoc(true)" @cancel="saveTransferDoc(false)" title="Подтвердите" size="sm" button-size="sm" ok-variant="success" ok-title="Да" cancel-variant="danger" cancel-title="Нет" centered no-close-on-backdrop no-close-on-esc>
			<p>Вы не сохраняете Накладной с сегодняшней датой. Если вы уверены то нажмите да, в противном случи оно сохранится с сегодняшней датой !</p>
		</b-modal>
	</div>
</template>

<script>
import Vue from 'vue';
import ContrAgentSelect from "../../../references/blocks/ContrAgentSelect";
import ContrAgentService from "../../../../services/contragent.service";
import UsersService from "../../../../services/users.sevice";
import WhDocument from "../../../../services/wh-document.service";
import Multiselect from 'vue-multiselect'
import ItemList from "./ItemList";
import Employees from "../mixins/Employee";
import MaskedInput from 'vue-masked-input'
import CreateItems from "./CreateItems";
import CurrencyService from "../../../../services/currency.service";
import {
	mapGetters,
	mapState,
	mapActions
} from "vuex";
import {
	validators
} from "../mixins/validators";

export default {
	name: 'CreateForm',

	mixins: [Employees, validators],

	components: {
		CreateItems,
		ContrAgentSelect,
		MaskedInput,
		Multiselect,
		SelectOrCreate: () => import('../../../components/SelectOrCreate'),
		ItemList
	},
	props: {
		mode: {
			type: String,
			default: 'create'
		},
		section: {
			type: String,
			default: 'KIRIM'
		},
		editItem: {
			type: Object,
			default: null
		}
	},

	data: function () {
		return {
			dateConfirmModal: false,
			depCurrencyId: null,
			incomeCurrencyId: null,
			fromCurrencyName: '',
			toCurrencyName: '',
			docTypes: [
				{id: 'PROTOKOL', name: 'Акт'},
				{id: 'PROTOKOL_EKSPERTIZA', name: 'Акт на экспертизу'}
			],
			item: {
				id: null,
				comment: null,
				action: 'KIRIM',
				documentType: 'NAKLADNOY',
				fromDepartmentId: null,
				fromDepartmentName: null,
				toDepartmentId: null,
				toDepartmentName: null,
				fromEmployeeId: null,
				fromEmployeeName: null,
				toEmployeeId: null,
				toEmployeeName: '',
				responsible1Id: null,
				responsible1Name: '',
				responsible2Id: null,
				responsible2Name: '',
				regNumber: '',
				regDate: null,
				contragentId: null,
				contragentName: '',
				reason: null,
				initiatorId: null,
				fromCurrencyRate: null,
				currencyId: null,
				toCurrencyRate: null,
				whItems: [],
				customsRegDate: '',
			},
			depWarning: false,
			toDepartmentForCurrency: {
				currencyName: ''
			},
			fromDepartmentForCurrency: {
				currencyName: ''
			},
			toggleCurrencyInputs: false,
			toggleCounter: 0,
			oldFromDepId: null,
			depCurrencyName: '',
			allTotalCount: 0,
			x: false,
			incomeTotal: 0,
			priceTotal: 0,
			dropDowns: {
				counterparties: {
					items: [],
					value: null
				},
				department: {
					items: [],
					value: null
				},
				transferPermittedDepartments: [],
				product: {
					items: [],
					value: null,
					loading: false,
					search: {
						page: 1,
						limit: 10,
						attributes: [{
							field: 'name',
							value: '',
							option: 'CONTAINS'
						}]
					}
				},
				units: {
					items: [],
					value: null
				},
				provider: {
					items: [],
					value: null
				},
				employees: {
					from: null,
					to: null,
					responsible: null,
					responsible2: null,
					initiator: null
				}
			},
			currencyRate: -1,
			showItems: true,
			foundIndexOfFromDep: -1
		}
	},

	methods: {
		...mapActions('references', [
			'getReferenceChildren',
		]),
		...mapActions('warehouse', [
			'clearInventoryList', 'getListByProductsNotKirim',
			'addRowVariantToXlsItems', 'resetExcelData'
		]),
		whItemsWatcherFn() {
			this.allTotalCount = 0;
			this.incomeTotal = 0;
			this.priceTotal = 0;
			if (this.formtItem.whItems) {
				this.formtItem.whItems.forEach(item => {
					this.incomeTotal += item.incomingPriceUsd ? item.incomingPriceUsd * item.count : 0;
					if (this.isOff) {
						this.priceTotal += (this.fromDepartmentForCurrency.saleType && this.fromDepartmentForCurrency.saleType === 'WHOLE') ? item.priceWholesale * item.count : item.priceUzs * item.count;
					} else {
						this.priceTotal += (this.toDepartmentForCurrency.saleType && this.toDepartmentForCurrency.saleType === 'WHOLE') ? item.priceWholesale * item.count : item.priceUzs * item.count;
					}
					this.allTotalCount += item.count;
				})
			}
		},
		depsSelected() {
			if (this.isTransfer) {
				if (this.formtItem.fromDepartmentId && this.formtItem.toDepartmentId) {
					return true;
				} else {
					return false;
				}
			}
			return true;
		},
		depWarningOk() {
			this.depWarning = false;
			this.$refs.depWarningModal.hide();
			Vue.set(this.formtItem, "whItems", []);
			// this.formtItem.whItems.forEach((item, index) => {
			// 	let foundIndex = this.formtItem.whItems.findIndex(el => {
			// 		return el.id = item.id
			// 	});
			// 	// WhDocument.removeItem(this.formtItem).then(() => {
			// 	// 	this.formtItem.whItems.splice(foundIndex, 1);
			// 	// 	this.formtItem.fromDepartmentId = newDepId;
			// 	// });
			// });
		},
		depWarningCancel() {
			this.formtItem.fromDepartmentId = this.oldFromDepId;
			this.depWarning = false;
			this.$refs.depWarningModal.hide();
		},
		async cancel() {
			this.$store.commit('warehouse/setWhDocDisabled', false);
			this.$emit('close', true);
		},
		async cancelAndClearInventory() {
			/*let payload = {
                    docuementId: this.formtItem.id,
                    departmentId: this.formtItem.fromDepartmentId,
                    items:this.formtItem.whItems
                }*/
			// await this.clearInventoryList(this.formtItem);
			this.$store.commit('warehouse/setWhDocDisabled', false);
			this.$store.commit('warehouse/setDepSaleTypeForDoc', null);
			this.$emit('docSuspended', 'forTransfer');
			this.$emit('close', true);
		},

		selectedCurrency() {
			this.toggleCurrencyInputs = true
			this.formtItem.fromCurrencyRate = null
			this.formtItem.toCurrencyRate = 1
			this.fromCurrencyName = localStorage.getItem('depCurrencyName')
			let toId = null
			this.refCurrencies.forEach(t => {
				if (t.id == this.formtItem.currencyId) {
					toId = t.id
					this.toCurrencyName = t.name
				}
			})
			CurrencyService.get(this.depCurrencyId, toId, this.formtItem.regDate).then(res => {
				this.formtItem.fromCurrencyRate = res.data
			}).catch(e => {
				this.$vs.notify({
					title: e.response,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
			})
		},

		exchange() {
			this.toggleCurrencyInputs = !this.toggleCurrencyInputs
			let toId = null
			let depName = ''
			this.refCurrencies.forEach(t => {
				if (t.id == this.formtItem.currencyId) {
					toId = t.id
					depName = t.name
				}
			})
			if (this.toggleCurrencyInputs) {
				this.formtItem.fromCurrencyRate = null
				this.formtItem.toCurrencyRate = 1
				this.fromCurrencyName = localStorage.getItem('depCurrencyName')
				CurrencyService.get(this.depCurrencyId, toId, this.formtItem.regDate).then(res => {
					this.formtItem.fromCurrencyRate = res.data
					this.toCurrencyName = depName
				}).catch(e => {
					this.$vs.notify({
						title: e.response,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				})
			} else {
				this.formtItem.fromCurrencyRate = 1
				this.formtItem.toCurrencyRate = null
				this.toCurrencyName = localStorage.getItem('depCurrencyName')
				CurrencyService.get(toId, this.depCurrencyId, this.formtItem.regDate).then(res => {
					this.formtItem.toCurrencyRate = res.data
					this.fromCurrencyName = depName
				}).catch(e => {
					this.$vs.notify({
						title: e.response,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				})
			}
		},

		/**
		 *
		 */
		fetchList() {
			ContrAgentService.search({
				page: 1,
				limit: 700
			}).then(response => {
				this.dropDowns.counterparties.items = response.data.items;
			})
		},

		/**
		 *
		 */
		fetchPermissions() {
			if (this.$can('get', 'permitted departments')) {
				UsersService.getPermittedDepartments().then(response => {
					this.dropDowns.department.items = response.data.permittedDepartments;
					this.dropDowns.transferPermittedDepartments = response.data.transferPermittedDepartments
				})
			}
		},

		async saveDocWriteOff(saveEnd) {
			this.$store.commit('warehouse/setWhDocDisabled', true);
			let item = {}
			if (this.editItem.id) {
				item = this.editItem
			} else {
				item = this.item
			}
			if (item.whItems.length > 0) {
				if (saveEnd) {
					item.documentStatus = 'READY'
					await WhDocument.saveDocWriteOff(item).then(res => {
						this.formtItem.id = res.data.id;
						this.$store.commit('warehouse/setWhDocDisabled', false);
						this.$emit('close', true);
						this.$vs.notify({
							text: 'Документ успешно сохранен',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						})
						setTimeout(() => {
							this.$router.push(`/warehouse-management/writeOff/view/${res.data.id}`)
						}, 500);
					}).catch(e => {
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
						this.$store.commit('warehouse/setWhDocDisabled', false);
					})
				} else {
					item.documentStatus = 'SUSPENDED'
					WhDocument.saveDocWriteOff(item).then(res => {
						this.formtItem.id = res.data.id;
						this.$emit('docSuspended', 'forOff');
						this.cancel();
						this.$vs.notify({
							text: 'Документ успешно сохранен',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						})
					}).catch(e => {
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
						this.$store.commit('warehouse/setWhDocDisabled', false);
					})
				}
			} else {
				this.$vs.notify({
					title: this.$t('words.error'),
					text: 'Пожалуйста, проверьте все поле еще раз',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
				this.$store.commit('warehouse/setWhDocDisabled', false);
				return 0;
			}
		},

		/**
		 * Store Warehouse document
		 */
		storeSusPend(update = false) {
			this.$store.commit('warehouse/setWhDocDisabled', true);

			if (!update) {
				this.setDocType();
				WhDocument.store(this.formtItem).then(response => {
					this.product.loading = true
					this.formtItem.id = response.data.id;
					if (response.data.regNumber) {
						this.formtItem.regNumber = response.data.regNumber
					}
					if (response.data.regDate) {
						this.formtItem.regDate = response.data.regDate
					}
					if (response.data.customsRegDate) {
						this.formtItem.customsRegDate = response.data.customsRegDate
					}
					this.$store.commit('warehouse/setWhDocDisabled', false);
				}).catch(error => {
					this.$store.commit('warehouse/setWhDocDisabled', false);
				});
			} else {
				if (this.isKirim) {
					if (this.notFoundItemsFromXls.length > 0) {
						this.$vs.notify({
							time: 4500,
							title: this.$t('addFromExcelMsg'),
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						});
						this.$store.commit('warehouse/setWhDocDisabled', false);
						return 0;
					} else {
						this.formtItem.documentStatus = 'SUSPENDED';
						WhDocument.editPrixodWithList(this.formtItem).then(response => {
							this.$emit('docSuspended', 'forIncome');
							this.cancel();
							this.$vs.notify({
								text: 'Документ успешно сохранен',
								color: 'success',
								icon: 'close',
								position: 'top-right'
							})
						})
							.catch(error => {
								this.$vs.notify({
									title: this.$t('words.error'),
									text: 'Пожалуйста, проверьте все поле еще раз',
									color: 'danger',
									icon: 'close',
									position: 'top-right'
								})
								this.$store.commit('warehouse/setWhDocDisabled', false);
							});
					}
				} else {
					this.$validator.validate().then(valid => {
						if (this.formtItem.whItems.length > 0) {
							let countErrorIndex = this.formtItem.whItems.findIndex(el => {
								return el.count <= 0;
							});
							if (countErrorIndex > -1) {
								this.$vs.notify({
									title: "Количество",
									text: 'Проверьте количество товаров!',
									color: 'warning',
									icon: 'close',
									position: 'top-right'
								});
								this.$store.commit('warehouse/setWhDocDisabled', false);
								return 0;
							}
							if (this.isTransfer) {
								if (this.formtItem.toDepartmentId) {
									let countErrorArray = [];
									this.formtItem.whItems.forEach((item, index) => {
										if (item.count > item.realBalance) {
											this.x = true;
											Vue.set(item, '_rowVariant', 'danger');
											let tempArr = [{
												index: index,
												item: item
											}];
											countErrorArray = [...countErrorArray, ...tempArr];
										}
									})
									// for (let k = 0; k < countErrorArray.length; k++) {
									// 	let foundIndex = this.formtItem.whItems.findIndex(el => el.id == countErrorArray[k].item.id);
									// 	if (foundIndex > -1) {
									// 		this.formtItem.whItems.splice(foundIndex, 1)
									// 	}
									// }
									// for (let j = 0; j < countErrorArray.length; j++) {
									// 	this.formtItem.whItems.unshift(countErrorArray[j].item);
									// }
									if (!this.x) {
										if (this.formtItem.toCurrencyRate == '') {
											this.formtItem.toCurrencyRate = null;
										} else if (this.formtItem.fromCurrencyRate == '') {
											this.formtItem.fromCurrencyRate = null;
										}
										this.formtItem.documentStatus = 'SUSPENDED';
										WhDocument.editTransferNew(this.formtItem).then(response => {
											this.formtItem.id = response.data.id;
											// this.$emit('redirect', response.data.id);
											this.cancel();
											this.$emit('docSuspended', 'forTransfer');
										}).catch(error => {
											this.$store.commit('warehouse/setWhDocDisabled', false);
										});
										return;
									} else {
										this.x = false;
										this.$vs.notify({
											title: this.$t('words.error'),
											text: 'Проверьте количество товара!',
											color: 'danger',
											icon: 'close',
											position: 'top-right'
										});
										this.$store.commit('warehouse/setWhDocDisabled', false);
										return;
									}
								} else {
									this.$vs.notify({
										title: "Выберите Подразделение (Получатель)",
										color: 'warning',
										icon: 'close',
										position: 'top-right'
									});
									this.$store.commit('warehouse/setWhDocDisabled', false);
									return 0;
								}
							} else {
								this.formtItem.documentStatus = 'SUSPENDED';
								WhDocument.update(this.formtItem).then(response => {
									this.formtItem.id = response.data.id;
									this.$emit('docSuspended', 'forIncome');
									this.cancel();
									this.$vs.notify({
										text: 'Документ успешно сохранен',
										color: 'success',
										icon: 'close',
										position: 'top-right'
									})
								}).catch(error => {
									this.$vs.notify({
										title: this.$t('words.error'),
										text: 'Пожалуйста, проверьте все поле еще раз',
										color: 'danger',
										icon: 'close',
										position: 'top-right'
									})
									this.$store.commit('warehouse/setWhDocDisabled', false);
								});
							}
						} else {

							Object.keys(this.validationFields).some(key => {
								this.validationFields[key].touched = true;
								this.validationFields[key].dirty = true;
								this.validationFields[key].changed = true;
							});

							this.$vs.notify({
								title: this.$t('words.error'),
								text: this.$t('department.please-fill'),
								color: 'danger',
								icon: 'close',
								position: 'top-right'
							})
							this.$store.commit('warehouse/setWhDocDisabled', false);
						}
					}).catch(error => {
						this.$vs.notify({
							title: this.$t('words.error'),
							text: 'Пожалуйста, проверьте все поле еще раз',
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
						this.$store.commit('warehouse/setWhDocDisabled', false);
					})
				}
			}
		},
		getTodayDate() {
			let today = new Date();
			var dd = String(today.getDate()).padStart(2, '0');
			var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
			var yyyy = today.getFullYear();
			today = dd + '-' + mm + '-' + yyyy;
			return String(today);
		},
		saveTransferDoc(tmp) {
			if (tmp) {
				this.formtItem.documentStatus = 'READY';
				WhDocument.editTransferNew(this.formtItem).then(response => {
					this.formtItem.id = response.data.id;
					this.$emit('redirect', response.data.id);
					this.cancel();
				}).catch(error => {
					this.$store.commit('warehouse/setWhDocDisabled', false);
				});
			} else {
				this.formtItem.regDate = this.getTodayDate();
				this.formtItem.documentStatus = 'READY';
				WhDocument.editTransferNew(this.formtItem).then(response => {
					this.formtItem.id = response.data.id;
					this.$emit('redirect', response.data.id);
					this.cancel();
				}).catch(error => {
					this.$store.commit('warehouse/setWhDocDisabled', false);
				});
			}
		},
		store(update = false) {
			this.$store.commit('warehouse/setWhDocDisabled', true);
			if (!update) {
				this.setDocType();
				WhDocument.store(this.formtItem).then(response => {

					this.formtItem.id = response.data.id;
					if (response.data.regNumber) {
						this.formtItem.regNumber = response.data.regNumber
					}
					if (response.data.regDate) {
						this.formtItem.regDate = response.data.regDate
					}
					if (response.data.customsRegDate) {
						this.formtItem.customsRegDate = response.data.customsRegDate
					}
					this.$store.commit('warehouse/setWhDocDisabled', false);
				}).catch(error => {
					this.$store.commit('warehouse/setWhDocDisabled', false);
				});
			} else {
				this.$validator.validate().then(valid => {
					if (valid && this.formtItem.whItems.length > 0) {
						let countErrorIndex = this.formtItem.whItems.findIndex(el => {
							return el.count <= 0;
						});
						if (countErrorIndex > -1) {
							this.$vs.notify({
								title: "Количество",
								text: 'Проверьте количество товаров!',
								color: 'warning',
								icon: 'close',
								position: 'top-right'
							});
							this.$store.commit('warehouse/setWhDocDisabled', false);
							return 0;
						}
						if (this.isTransfer) {
							if (this.formtItem.toDepartmentId) {
								let countErrorArray = [];
								this.formtItem.whItems.forEach((item, index) => {
									if (item.count > item.realBalance) {
										this.x = true;
										Vue.set(item, '_rowVariant', 'danger');
										let tempArr = [{
											index: index,
											item: item
										}];
										countErrorArray = [...countErrorArray, ...tempArr];
									}
								})
								for (let k = 0; k < countErrorArray.length; k++) {
									let foundIndex = this.formtItem.whItems.findIndex(el => el.id == countErrorArray[k].item.id);
									if (foundIndex > -1) {
										this.formtItem.whItems.splice(foundIndex, 1)
									}
								}
								for (let j = 0; j < countErrorArray.length; j++) {
									this.formtItem.whItems.unshift(countErrorArray[j].item);
								}
								if (!this.x) {
									if (this.formtItem.toCurrencyRate == '') {
										this.formtItem.toCurrencyRate = null;
									} else if (this.formtItem.fromCurrencyRate == '') {
										this.formtItem.fromCurrencyRate = null;
									}
// ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
									if (this.formtItem.regDate !== this.getTodayDate()) {
										this.dateConfirmModal = true
										return;
									} else {
										this.formtItem.documentStatus = 'READY';
										WhDocument.editTransferNew(this.formtItem).then(response => {
											this.formtItem.id = response.data.id;
											this.$emit('redirect', response.data.id);
											this.cancel();
										}).catch(error => {
											this.$store.commit('warehouse/setWhDocDisabled', false);
										});
										return;
									}
// ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
								} else {
									this.$vs.notify({
										title: this.$t('words.error'),
										text: 'Проверьте количество товара!',
										color: 'danger',
										icon: 'close',
										position: 'top-right'
									})
									this.$store.commit('warehouse/setWhDocDisabled', false);
									return;
								}
							} else {
								this.$vs.notify({
									title: "Выберите Подразделение (Получатель)",
									color: 'warning',
									icon: 'close',
									position: 'top-right'
								});
								this.$store.commit('warehouse/setWhDocDisabled', false);
								return 0;
							}
						}
						if (this.isKirim) {
							if (this.notFoundItemsFromXls.length > 0) {
								this.$vs.notify({
									time: 4500,
									title: this.$t('addFromExcelMsg'),
									color: 'warning',
									icon: 'close',
									position: 'top-right'
								});
								this.$store.commit('warehouse/setWhDocDisabled', false);
								return 0;
							} else {
								this.formtItem.documentStatus = 'READY';
								WhDocument.editPrixodWithList(this.formtItem).then(response => {
									this.$emit('docSuspended', 'forIncome');
									this.cancel();
									this.$vs.notify({
										text: 'Документ успешно сохранен',
										color: 'success',
										icon: 'close',
										position: 'top-right'
									})
								})
									.catch(error => {
										this.$vs.notify({
											title: this.$t('words.error'),
											text: 'Пожалуйста, проверьте все поле еще раз',
											color: 'danger',
											icon: 'close',
											position: 'top-right'
										})
										this.$store.commit('warehouse/setWhDocDisabled', false);
									});
							}
						} else {
							this.formtItem.documentStatus = 'READY';
							WhDocument.update(this.formtItem).then(response => {
								this.formtItem.id = response.data.id;
								this.$emit('redirect', response.data.id);
								this.cancel();
							}).catch(error => {
								this.$vs.notify({
									title: this.$t('words.error'),
									text: 'Пожалуйста, проверьте все поле еще раз',
									color: 'danger',
									icon: 'close',
									position: 'top-right'
								})
								this.$store.commit('warehouse/setWhDocDisabled', false);
							});
						}
					} else {
						Object.keys(this.validationFields).some(key => {
							this.validationFields[key].touched = true;
							this.validationFields[key].dirty = true;
							this.validationFields[key].changed = true;
						});

						this.$vs.notify({
							title: this.$t('words.error'),
							text: this.$t('department.please-fill'),
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
						this.$store.commit('warehouse/setWhDocDisabled', false);
					}
				}).catch(error => {
					this.$vs.notify({
						title: this.$t('words.error'),
						text: 'Пожалуйста, проверьте все поле еще раз',
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
					this.$store.commit('warehouse/setWhDocDisabled', false);
				})
			}
		},

		setDocType() {
			if (this.isChiqim || this.isTransfer) {
				this.formtItem.documentType = 'AKT';
			}
			if (this.isOff) {
				this.formtItem.documentType = 'PROTOKOL';
			}
		},

		/**
		 *  Add Warehouse item
		 */
		async addItem($event) {
			/*if (this.mode === 'edit') {
                    this.showItems = false;
                    this.loadWhItems(this.formtItem.id)
                }*/
			let findIndex = this.formtItem.whItems.findIndex(el => {
				if (this.isKirim) {
					return el.itemId == $event.itemId && el.termOfItem == $event.termOfItem && el.incomingPriceUsd == $event.incomingPriceUsd;
				} else if (this.isOff) {
					let tempBoolean = el.itemId == $event.itemId && el.regNumber == $event.regNumber && el.termOfItem == $event.termOfItem  && (el.price ? el.price == $event.price : ((this.depSaleType && this.depSaleType == 'WHOLE') ? el.priceWholesale == $event.price : el.priceUzs == $event.price));
					return tempBoolean
				} else {
					let tempBoolean = el.itemId == $event.itemId && el.termOfItem == $event.termOfItem  && (el.price ? el.price == $event.price : ((this.depSaleType && this.depSaleType == 'WHOLE') ? el.priceWholesale == $event.price : el.priceUzs == $event.price));
					return tempBoolean
				}
			});
			if (findIndex >= 0) {
				if ($event.priceUzs || $event.incomingPriceUzs >= 0) {
					this.formtItem.whItems[findIndex].count = parseInt(this.formtItem.whItems[findIndex].count) + parseInt($event.count);
					this.formtItem.whItems[findIndex].incomingPriceUzs = $event.incomingPriceUzs ? $event.incomingPriceUzs : this.formtItem.whItems[findIndex].incomingPriceUzs;
					this.formtItem.whItems[findIndex].priceUzs = $event.priceUzs ? $event.priceUzs : this.formtItem.whItems[findIndex].priceUzs;
					let temp = this.formtItem.whItems[findIndex];
					if (temp._rowVariant) {
						if (temp._rowVariant == 'primary') {
							temp._rowVariant = 'warning';
						} else if (temp._rowVariant == 'warning') {
							temp._rowVariant = 'success';
						} else if (temp._rowVariant == 'success') {
							temp._rowVariant = 'warning';
						} else {
							temp._rowVariant = 'warning';
						}
					} else {
						temp._rowVariant = 'warning'
					}
					this.formtItem.whItems.forEach((el, index) => {
						if (index !== findIndex) {
							delete el['_rowVariant'];
						}
					});
					this.formtItem.whItems.splice(findIndex, 1);
					this.formtItem.whItems.unshift(temp);
				} else {
					this.formtItem.whItems[findIndex].count = parseInt(this.formtItem.whItems[findIndex].count) + parseInt($event.count);
					let temp = this.formtItem.whItems[findIndex];
					if (temp._rowVariant) {
						if (temp._rowVariant == 'primary') {
							temp._rowVariant = 'warning';
						} else if (temp._rowVariant == 'warning') {
							temp._rowVariant = 'success'
						} else if (temp._rowVariant == 'success') {
							temp._rowVariant = 'warning'
						}
					} else {
						temp._rowVariant = 'warning'
					}
					this.formtItem.whItems.forEach((el, index) => {
						if (index !== findIndex) {
							delete el['_rowVariant'];
						}
					});
					this.formtItem.whItems.splice(findIndex, 1);
					this.formtItem.whItems.unshift(temp);
				}
			} else {
				this.formtItem.whItems.forEach(el => {
					delete el['_rowVariant'];
				});
				$event._rowVariant = 'primary';
				$event.realBalance = $event.inventoryNum;
				this.formtItem.whItems.unshift($event);
			}
			this.$vs.notify({
				time: 1500,
				title: this.$t('add-product'),
				color: 'success',
				icon: 'close',
				position: 'top-right'
			});
		},
		async successExcel() {
			await this.addRowVariantToXlsItems();
			await this.removeRowVariantFromWhItems();
			this.foundItemsFromXls.forEach(el => {
				let foundIndex = this.formtItem.whItems.findIndex(x => x.itemId == el.itemId && x.termOfItem == el.termOfItem);
				if (foundIndex > -1) {
					this.formtItem.whItems[foundIndex].count += el.count;
				} else {
					this.formtItem.whItems.unshift(el);
				}
			})
			//this.formtItem.whItems.unshift(...this.foundItemsFromXls);
		},
		async cancelExcel() {
			if (this.foundItemsFromXls.length > 0) {
				let vm = this;
				this.formtItem.whItems = this.formtItem.whItems.filter(function (el) {
					return vm.foundItemsFromXls.indexOf(el) < 0;
				});

				// let excelItemsOriginal = JSON.stringify(this.foundItemsFromXls.slice());
				// excelItemsOriginal = JSON.parse(excelItemsOriginal);
				// let sum = [];
				// excelItemsOriginal.forEach(el => {
				// 	let foundIndex = sum.findIndex(x => x.itemId == el.itemId);
				// 	if (foundIndex > -1) {
				// 		sum[foundIndex].count += el.count;
				// 	} else {
				// 		sum.push(el);
				// 	}
				// })
				// this.formtItem.whItems.forEach(function(el, index, object) {
				// 	if (excelItemsOriginal.filter(a => a.itemId === object[index].itemId).length <= 0) {
				// 		// return true
				// 	} else {
				// 		let foundIndex = excelItemsOriginal.findIndex(item => item.itemId == object[index].itemId)
				// 		if (foundIndex > -1) {
				// 			object[index].count -= excelItemsOriginal[foundIndex].count;
				// 		}
				// 		// return true;
				// 	}
				// 	//return vm.foundItemsFromXls.indexOf( el ) < 0;
				// })
			}
			await this.resetExcelData();
			//this.formtItem.whItems.unshift(...this.foundItemsFromXls);
		},
		removeRowVariantFromWhItems() {
			this.formtItem.whItems.forEach((el, index) => {
				delete el['_rowVariant'];
			});
		},
		changeRowVariant(findIndex) {
			let temp = this.formtItem.whItems[findIndex];
			/*if (temp._rowVariant) {
                    if (temp._rowVariant == 'primary') {
                        temp._rowVariant = 'warning';
                    } else if (temp._rowVariant == 'warning') {
                        temp._rowVariant = 'success'
                    } else if (temp._rowVariant == 'success') {
                        temp._rowVariant = 'warning'
                    }
                } else {
                    temp._rowVariant = 'warning'
                }*/
			temp._rowVariant = 'danger'
			this.formtItem.whItems.forEach((el, index) => {
				if (index !== findIndex) {
					delete el['_rowVariant'];
				}
			});
			this.formtItem.whItems.splice(findIndex, 1);
			this.formtItem.whItems.unshift(temp);
		},

		/**
		 * Remove Warehouse item
		 * @param $event
		 */
		removeItem($event) {
			if (this.isTransfer || this.isKirim || this.isOff) {
				let res = -1;
				if (this.isTransfer || this.isOff) {
					if (this.isOff) {
						if (this.fromDepartmentForCurrency.saleType == 'RETAIL') {
							res = this.formtItem.whItems.findIndex(el => el.itemId == $event.itemId && el.priceUzs == $event.priceUzs)
						} else {
							res = this.formtItem.whItems.findIndex(el => el.itemId == $event.itemId && el.priceWholesale == $event.priceWholesale)
						}
					} else {
						if (this.toDepartmentForCurrency.saleType == 'RETAIL') {
							res = this.formtItem.whItems.findIndex(el => el.itemId == $event.itemId && el.priceUzs == $event.priceUzs)
						} else {
							res = this.formtItem.whItems.findIndex(el => el.itemId == $event.itemId && el.priceWholesale == $event.priceWholesale)
						}
					}
				} else {
					res = this.formtItem.whItems.findIndex(el => el.itemId == $event.itemId)
				}
				if (res > -1) {
					this.formtItem.whItems.splice(res, 1)
				}
				return 1;
			} else {
				let res2 = this.formtItem.whItems.findIndex(el => el.itemId == $event.itemId && el.price == $event.price)
				WhDocument.removeItemId(this.formtItem, this.formtItem.whItems[res2].id).then(() => {
					this.formtItem.whItems.splice($event, 1);
				});
			}
		},

		setDropdowns() {
			this.dropDowns.counterparties.value = (this.editItem.contragentId) ? this.editItem.contragentId : null;

			this.dropDowns.employees.from = (this.editItem.fromEmployeeId) ? {
				id: this.editItem.fromEmployeeId,
				firstName: this.editItem.fromEmployeeName
			} : null;

			this.dropDowns.employees.to = (this.editItem.toEmployeeId) ? {
				id: this.editItem.toEmployeeId,
				firstName: this.editItem.toEmployeeName
			} : null;
			this.dropDowns.employees.responsible = (this.editItem.responsible1Id) ? {
				id: this.editItem.responsible1Id,
				firstName: this.editItem.responsible1Name
			} : null;
			this.dropDowns.employees.responsible2 = (this.editItem.responsible2Id) ? {
				id: this.editItem.responsible2Id,
				firstName: this.editItem.responsible2Name
			} : null;


		},

		async loadWhItems(documentId) {

			if (this.isTransfer) {
				await WhDocument.byDocumentForTransfer(documentId).then(response => {
					/**
					 * Hozirgi Javascript qoidalari bilan Vue js Objectdagi har qanday o'zgarishni Reactive seza olmaydi,
					 * shu sababdan Obyectga yangi property qo'shayotganda 'Vue.set' ishlatiladi (https://vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats).
					 */
					response.data.forEach(el => {
						Vue.set(el, 'wrappedItems', el.whWrappedItems)
					})
					Vue.set(this.formtItem, 'whItems', response.data);
					// this.formtItem['whItems'] = response.data;
					if (this.isKirim && this.formtItem.currencyId) {
						this.selectedCurrency();
					}
					this.showItems = true;
				}).catch(er => {
					this.showItems = false;
				})
			} else if (this.isOff) {
				await WhDocument.byDocumentForWriteOff(documentId).then(response => {
					/**
					 * Hozirgi Javascript qoidalari bilan Vue js Objectdagi har qanday o'zgarishni Reactive seza olmaydi,
					 * shu sababdan Obyectga yangi property qo'shayotganda 'Vue.set' ishlatiladi (https://vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats).
					 */
					response.data.forEach(el => {
						Vue.set(el, 'wrappedItems', el.whWrappedItems)
					})
					Vue.set(this.formtItem, 'whItems', response.data);
					// this.formtItem['whItems'] = response.data;
					if (this.isKirim && this.formtItem.currencyId) {
						this.selectedCurrency();
					}
					this.showItems = true;
				}).catch(er => {
					this.showItems = false;
				})
			} else {
				await WhDocument.byDocument(documentId).then(response => {
					/**
					 * Hozirgi Javascript qoidalari bilan Vue js Objectdagi har qanday o'zgarishni Reactive seza olmaydi,
					 * shu sababdan Obyectga yangi property qo'shayotganda 'Vue.set' ishlatiladi (https://vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats).
					 */
					response.data.forEach(el => {
						Vue.set(el, 'wrappedItems', el.whWrappedItems)
					})
					Vue.set(this.formtItem, 'whItems', response.data);
					// this.formtItem['whItems'] = response.data;
					if (this.isKirim && this.formtItem.currencyId) {
						this.selectedCurrency();
					}
					this.showItems = true;
				}).catch(er => {
					this.showItems = false;
				})
			}

		},

		fullName({
					 firstName,
					 lastName,
					 middleName
				 }) {
			return `${firstName} ${lastName} ${middleName}`;
		},
	},

	created() {
		window.addEventListener('beforeunload', (event) => {
			// event.returnValue = `Are you sure you want to leave?`;
			if (this.formtItem) {
				if (this.formtItem.whItems.length > 0) {
					this.cancelAndClearInventory();
				}
			}
		});
	},
	async mounted() {
		this.depCurrencyId = localStorage.getItem("depCurrencyId");
		await this.getReferenceChildren('CURRENCY');
		this.fetchList();
		this.fetchPermissions();
		if (this.mode === 'create') {
			this.item.action = this.section;
			this.store();
		} else {
			this.showItems = false;
			this.setDropdowns();
			// CurrencyService.get(this.editItem.toDepartmentId).then(response => {
			// 	this.currencyRate = response.data;
			// });
			await this.loadWhItems(this.editItem.id);
		}
	},

	watch: {

		'dropDowns.department.items': {
			deep: true,
			handler(newValue) {
				if (this.mode !== 'create' && newValue) {
					if (this.isKirim) {
						let fromDepTemp = this.dropDowns.department.items.find(item => {
							return item.id == this.editItem.toDepartmentId;
						});
						this.depCurrencyName = fromDepTemp ? fromDepTemp.currencyName : this.userDepCurrencyName;
					} else {
						let fromDepTemp = this.dropDowns.department.items.find(item => {
							return item.id == this.editItem.fromDepartmentId;
						});
						this.depCurrencyName = fromDepTemp ? fromDepTemp.currencyName : this.userDepCurrencyName;
					}
				}
			}
		},
		'dropDowns.employees.to': {
			handler(newValue) {
				if (!newValue) {
					return false;
				}
				this.formtItem.toEmployeeId = newValue.id
			}
		},
		'dropDowns.employees.from': {
			handler(newValue) {
				if (!newValue) {
					return false;
				}
				this.formtItem.fromEmployeeId = newValue.id
			}
		},
		'dropDowns.employees.responsible': {
			handler(newValue) {
				if (!newValue) {
					return false;
				}
				this.formtItem.responsible1Id = newValue.id
			}
		},
		'dropDowns.employees.responsible2': {
			handler(newValue) {
				if (!newValue) {
					return false;
				}
				this.formtItem.responsible2Id = newValue.id
			}
		},
		'dropDowns.employees.initiator': {
			handler(newValue) {
				if (!newValue) {
					return false;
				}
				this.formtItem.initiatorId = newValue.id
			}
		},

		'formtItem.whItems': {
			deep: true,
			handler() {
				this.whItemsWatcherFn();
			}
		},
		'formtItem.toDepartmentId': {
			deep: true,
			handler(newValue) {
				this.depsSelected();
				if (newValue) {
					let foundDep = this.dropDowns.transferPermittedDepartments.find(item => {
						return item.id == newValue;
					});
					if (!foundDep) {
						this.toDepartmentForCurrency = {
							currencyName: ''
						}
						if (this.isTransfer) {
							this.$store.commit('warehouse/setDepSaleTypeForDoc', null);
						}
					} else {
						this.toDepartmentForCurrency = Object.assign({}, foundDep);
						if (this.isTransfer) {
							this.$store.commit('warehouse/setDepSaleTypeForDoc', this.toDepartmentForCurrency.saleType);
						}
						this.whItemsWatcherFn();
					}
					// if (this.isKirim) {
					// 	this.depCurrencyName = this.toDepartmentForCurrency ? this.toDepartmentForCurrency.currencyName : '';
					// 	CurrencyService.get(newValue).then(response => {
					// 		this.currencyRate = response.data;
					// 	})
					// }
				}
			}
		},
		'formtItem.fromDepartmentId': {
			deep: true,
			handler(newVal, oldVal) {
				this.depsSelected();
				if (newVal) {
					let foundDep = this.dropDowns.department.items.find(item => {
						return item.id == newVal;
					});
					if (!foundDep) {
						this.fromDepartmentForCurrency = {
							currencyName: ''
						}
						if (!this.isTransfer) {
							this.$store.commit('warehouse/setDepSaleTypeForDoc', null);
						}
					} else {
						this.fromDepartmentForCurrency = Object.assign({}, foundDep);
						if (!this.isTransfer) {
							this.$store.commit('warehouse/setDepSaleTypeForDoc', this.fromDepartmentForCurrency.saleType);
							this.whItemsWatcherFn();
						}
					}
					this.depCurrencyName = this.fromDepartmentForCurrency ? this.fromDepartmentForCurrency.currencyName : '';
				}
				this.depWarning = false;
			}
		},
		// toggleCurrencyInputs: {
		// 	handler(newVal) {
		// 		this.toggleCounter++;
		// 		if (newVal) {
		// 			this.formtItem.fromCurrencyRate = 1;
		// 			this.formtItem.toCurrencyRate = null;
		// 		} else {
		// 			this.formtItem.toCurrencyRate = 1;
		// 			this.formtItem.fromCurrencyRate = null;
		// 		}
		// 	}
		// }
	},

	computed: {
		...mapState('references', [
			'refCurrencies'
		]),
		...mapState(['userDepCurrencyName']),
		...mapGetters('warehouse', ['wTypes']),
		...mapState('warehouse', [
			'whDocSaveDisabled', 'depSaleType',
			'balance', 'foundItemsFromXls', 'notFoundItemsFromXls'
		]),
		computedDepSaleTypeForChild() {
			if (this.isTransfer) {
				if (this.toDepartmentForCurrency.saleType) {
					return this.toDepartmentForCurrency.saleType;
				} else {
					return '';
				}
			} else {
				if (this.fromDepartmentForCurrency.saleType) {
					return this.fromDepartmentForCurrency.saleType
				} else {
					return '';
				}
			}
		},
		currencyDisabler() {
			return !this.isKirim;
		},
		incomeCurrency() {
			let temp = {
				name: ''
			};
			if (this.formtItem.currencyId && this.refCurrencies.length > 0) {
				temp = this.refCurrencies.find(el => {
					return el.id == this.formtItem.currencyId;
				})
			}
			this.depCurrencyName = temp.name;
			return temp;
		},
		isIncomeCurrencyChanged() {
			if (this.toDepartmentForCurrency && this.formtItem.currencyId) {
				if (!this.toggleCurrencyInputs) {
					this.formtItem.fromCurrencyRate = 1;
					if (this.mode !== 'edit' || this.toggleCounter > 0) {
						this.formtItem.toCurrencyRate = null;
					}
				} else {
					this.formtItem.fromCurrencyRate = null;
					this.formtItem.toCurrencyRate = 1;
				}
				if (this.toDepartmentForCurrency.currencyId && this.formtItem.currencyId) {
					return this.toDepartmentForCurrency.currencyId !== this.formtItem.currencyId;
				} else {
					return false;
				}
			} else {
				return false;
			}
		},
		isCurrenciesDifferent() {
			if (this.toDepartmentForCurrency) {
				if (this.toDepartmentForCurrency.id && this.fromDepartmentForCurrency.id) {
					if (!this.toggleCurrencyInputs) {
						this.formtItem.fromCurrencyRate = 1;
						this.formtItem.toCurrencyRate = null;
					} else {
						this.formtItem.fromCurrencyRate = null;
						this.formtItem.toCurrencyRate = 1;
					}
					if (this.toDepartmentForCurrency.currencyId && this.fromDepartmentForCurrency.currencyId) {
						return this.toDepartmentForCurrency.currencyId !== this.fromDepartmentForCurrency.currencyId;
					} else {
						return false;
					}
				} else {
					return false;
				}
			} else {
				return false
			}
		},
		formtItem() {
			if (this.mode === 'create') {
				return this.item;
			} else {
				return this.editItem;
			}
		},
		depWarningComputed() {
			return this.depWarning;
		},
		isChiqim() {
			return this.section === 'CHIQIM';
		},
		isOff() {
			return this.section === 'SPISAT';
		},

		isTransfer() {
			return this.section === 'KOCHIRISH';
		},

		isKirim() {
			return this.section === 'KIRIM';
		},
		departments() {
			const departments = [];
			this.dropDowns.department.items.map(item => {
				if (this.wTypes.includes(item.typeName))
					departments.push({
						value: item.id,
						text: `${item.name} ${(item.parentName) ? '-' + item.parentName : ''}`
					});
			});
			if (this.formtItem.fromDepartmentId) {
				let customDepartments = {}
				customDepartments.fromDepartmentId = this.formtItem.fromDepartmentId;
				customDepartments.toDepartmentId = this.formtItem.toDepartmentId;
				customDepartments.section = this.section;

				this.$store.commit('warehouse/setFromDepartmentId', customDepartments);
				this.foundIndexOfFromDep = departments.findIndex(el => el.value == this.formtItem.fromDepartmentId);
			} else {
				this.foundIndexOfFromDep = -1;
			}
			return departments;
		},
		toDepartments() {
			const departments = [];
			this.dropDowns.transferPermittedDepartments.map(item => {
				if (this.wTypes.includes(item.typeName))
					departments.push({
						value: item.id,
						text: `${item.name} - ${item.parentName}`,
						saleType: item.saleType
					});
			});
			if (this.foundIndexOfFromDep !== -1) {
			}
			return departments;
		},

		departmentId() {
			let customDepartments = {}
			customDepartments.fromDepartmentId = this.formtItem.fromDepartmentId;
			customDepartments.toDepartmentId = this.formtItem.toDepartmentId;
			customDepartments.section = this.section;

			this.$store.commit('warehouse/setFromDepartmentId', customDepartments);
			return this.isKirim ? this.formtItem.toDepartmentId : this.formtItem.fromDepartmentId;
		}
	}
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
<style scoped>.fromCurrencyRateId + div {
	padding: 0 !important;
}
</style>
